import React from 'react';

const Venue = ()=> (
    <div>
        <h2>Venue</h2>
        <p>Coming Soon</p>
    </div>
);

export default Venue;